import React from 'react';
import { useCodenameChangedHandler, useOnModuleEnded, useVideoComponent, } from '../../../adapters';
import { useDestination } from '../../../routing/hooks';
import { showCaptions } from '../../../redux/slices/closedCaptions';
import { getFirst } from '../../../helpers/utilities';
import { useAppDispatch } from '../../../redux/hooks';
export function VideoExplainerPage({ basePage, customPage, }) {
    const moduleTaxonomyValue = basePage.elements.module.value[0]?.codename;
    const moduleIsEnding = moduleTaxonomyValue === 'end' || 'single_page_module';
    const destination = useDestination(basePage.elements.linked_destinations.linkedItems);
    const changeCodename = useCodenameChangedHandler();
    const onModuleEnded = useOnModuleEnded();
    const VideoComponent = useVideoComponent();
    const dispatch = useAppDispatch();
    // TODO PARA-942 parabola actions. this maybeAdvanceToDestination callback is a shared pattern between our existing page types. it is the likely place where we will introduce parabola actions and is a candidate for abstraction.
    const maybeAdvanceToDestination = () => {
        // TODO exercise this once tests are integrated back into this repo
        if (moduleIsEnding) {
            return onModuleEnded();
        }
        if (destination) {
            changeCodename(destination);
        }
    };
    const mp4Asset = customPage && hasAsset(customPage.elements.mp4_file)
        ? customPage.elements.mp4_file
        : basePage.elements.mp4_file;
    const ccAsset = customPage && hasAsset(customPage.elements.cc)
        ? customPage.elements.cc
        : basePage.elements.cc;
    const dtAsset = customPage && hasAsset(customPage.elements.dynamic_text)
        ? customPage.elements.dynamic_text
        : basePage.elements.dynamic_text;
    return (React.createElement(VideoComponent, { src: getFirst(mp4Asset.value).url, trackSrc: getFirst(ccAsset.value).url, dynamicTextSrc: dtAsset.value[0]?.url, audioOnly: false, onEnded: maybeAdvanceToDestination, onCueChange: (captions) => dispatch(showCaptions(captions)) }));
}
const hasAsset = (assetElement) => {
    return assetElement.value.length > 0;
};
//# sourceMappingURL=VideoExplainerPage.js.map